import { 
    getMeterHouseList,
    } from "@/apis/mb/company/meterRecord.js"; 

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_mb_biz_meter_house_list: 'bizMbMeterRecord/set_mb_biz_meter_house_list',
    set_filter_query: 'bizMbMeterRecord/set_filter_query',
}

// count state 必須是 Object
const state = {
    meterHouseList: [],
    filterQuery: {
        county: null,
        district: null,
        noPic: false,
        date: [],
    },
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_MB_BIZ_METER_HOUSE_LIST: (state) => {
        return state.meterHouseList
    },
    GET_MB_BIZ_METER_HOUSE_FILTER_QUERY: (state) => {
        return state.filterQuery
    },
    GET_MB_BIZ_METER_HOUSE_FILTER_DEFAULT: (state) => {
        return state.isDefault
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getMbBizMeterHouseList ( {commit} ) {
        return new Promise((resolve, reject) => {
            getMeterHouseList()
            .then(res => {
                // console.log(res)
                if( res.data.status == "SUCCESS" ){
                    console.log(res)
                    commit(types.set_mb_biz_meter_house_list, res.data.result);
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
            
        })
    },
    setMbBizMeterHouseFilterQuery ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_query, value);
            resolve()
        })
    },
    // setMbBizMeterHouseFilterDefault ( {commit} ) {
    //     return new Promise((resolve, reject) => {
    //         let filter = {
    //             group: '',
    //             member: '',
    //             status: '',
    //             type: '',
    //             leaseTerm: '',
    //             date: [],
    //             county: '',
    //             district: '',
    //             rent: [0, 100000],
    //         }
    //         commit(types.set_filter_default, filter);
    //         resolve()
    //     })
    // },
}

// mutations
const mutations = {
    [types.set_mb_biz_meter_house_list](state, data){
        state.meterHouseList = data
    },
    [types.set_filter_query](state, data){
        state.filterQuery = data
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/mb/enterprise/meterRecord.js